import { render, staticRenderFns } from "./DataFieldList.vue?vue&type=template&id=5d814c21&"
import script from "./DataFieldList.vue?vue&type=script&lang=js&"
export * from "./DataFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports